import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IModelObject } from 'src/app/model/model-interface';

@Injectable()
export class ComponentCommunicationService {

  componentChannel: Subject<IModelObject>;

  constructor() { 
    this.componentChannel = new Subject<IModelObject>();
  }

  public sendMessage(modelObject: IModelObject) {
    this.componentChannel.next(modelObject);
  }
}
